<template>
  <div class="volunteer h-100">
    <div class="volunteer-inner">
      <div class="form-wrapper">
        <el-form ref="form" :model="addForm" :rules="rules" label-width="160px">
          <div class="left">

            <el-form-item label="宣传图片：" class="avatar-uploader-form" prop="pic1">
              <!-- <div class="uploader-form" @click="uploadPicture(1)">
                <img v-if="addForm.pic1" :src="addForm.pic1" alt="">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </div> -->
              <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" :disabled="!editFlag"
                accept="image/*" :data="configData" :show-file-list="false" :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <img v-if="imgUrl" style="height:100%;width: 100%;;object-fit:contain;" :src="imgUrl" class="avatar">
                <div v-else>
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <div class="el-upload__text">上传文创封面</div>
                </div>
              </el-upload>

              <div class="tip-img">建议图片大小：375 * 250</div>
            </el-form-item>

            <!-- <el-form-item class="avatar-uploader-form video-wrapper" label="宣传视频：" prop="pic2">
              <el-upload class="avatar-uploader" action="/singleMuseum/attach/upload" accept="video/*" :disabled="!editFlag" :data="configData" :show-file-list="false" :on-change="uploadVideoProcess" :on-success="handleVideoSuccess" :before-upload="beforeVideoUpload">

                <video v-if="addForm.pic2 != '' && !videoFlag" v-bind:src="addForm.pic2" class="video-wrapper" controls="controls">
                  您的浏览器不支持视频播放
                </video>

                <div class="tip" v-else-if="addForm.pic2 == '' && !videoFlag">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <div class="el-upload__text">上传儿童体验馆宣传视频</div>
                </div>

                <el-progress v-if="videoFlag == true" type="circle" v-bind:percentage="videoUploadPercent" style="margin-top: 7px"></el-progress>
              </el-upload>

              <div class="tip-img" >建议视频大小：375 * 325</div>
            </el-form-item>

            <el-form-item class="avatar-uploader-form" label="视频封面：">
              <div class="uploader-form" @click="uploadPicture(3)">
                <img v-if="addForm.pic3" :src="addForm.pic3" alt="">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </div>
              <div class="tip-img">建议图片大小：375 * 325</div>
            </el-form-item> -->
          </div>

          <el-form-item class="right" label="儿童体验馆介绍：" prop="des">
            <cmp-ckeditor ref="myCkeditor1" :readOnly="!editFlag" :defaultMsg="addForm.des" :id="`ue2`"
              :height="600"></cmp-ckeditor>
          </el-form-item>
        </el-form>
      </div>
    </div>

    <div class="btn">
      <el-button v-if="editFlag" class="el-primary-border" :loading="loadingSave" round @click="onSubmit">确定</el-button>
      <el-button v-else class="el-primary-border" round @click="onEdit">编辑</el-button>
    </div>

    <!-- 剪裁组件弹窗 -->
    <cropper-image ref="cropperRef" @uploadImgSuccess="handleUploadSuccess">
    </cropper-image>
  </div>
</template>

<script>
import cmpUploadProgress from '@cmp/my-upload/upload-progress'
import CropperImage from "@cmp/cropper";
import cmpCkeditor from '@cmp/editor/ckeditor'
import { mapGetters } from 'vuex'
export default {
  components: {
    cmpCkeditor,
    CropperImage,
    cmpUploadProgress
  },
  computed: {
    ...mapGetters(['imageTypes']),
  },
  props: ['type'],
  data() {
    // const validateSp = (rule, value, callback) => {
    //   if (!this.addForm.pic2) {
    //     callback(new Error('招募视频不能为空'))
    //   } else {
    //     callback()
    //   }
    // }

    const validateZmfm = (rule, value, callback) => {
      if (!this.addForm.pic1) {
        callback(new Error('招募封面不能为空'))
      } else {
        callback()
      }
    }
    return {
      addForm: {
        pic1: '',
        pic2: '',
        pic3: '',
        des: ''
      },
      rules: {
        pic1: [{ required: true, validator: validateZmfm, trigger: 'blur' }],
        // pic2: [{ required: true, validator: validateSp, trigger: 'blur' }],
      },
      configData: {
        tableName: 'collect'
      },
      picType: '',
      imgUrl: '',
      editFlag: false,
      typeList: [{
        dictCode: '1',
        dictName: '是'
      }, {
        dictCode: '0',
        dictName: '否'
      }],
      loadingSave: false,
      videoUrl: '', //宣传视频地址
      videoFlag: false, //上传加载状态
      videoUploadPercent: 0,
      listLoading: false,
      coverUrl: "", //封面地址
      serviceUrl: ""

    }
  },

  methods: {
    handleUploadSuccess(result) {
      switch (this.picType) {
        case 1:
          this.addForm.pic1 = result.attPath
          if (this.addForm.pic1) {
            this.$refs.form.clearValidate('pic1');
          }
          break
        case 2:
          this.addForm.pic2 = result.attPath
          break
        case 3:
          this.addForm.pic3 = result.attPath
          break
      }
      this.imgUrl = ""
      this.cropperModel = false
    },
    handleAvatarSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.imgUrl = res.result.attPath
        this.addForm.pic1 = res.result.attPath
        if (this.addForm.pic1) {
          this.$refs['addForm'].clearValidate(['pic1'])
        }
      } else {
        this.$message.error(res.message)
      }
    },

    
    beforeAvatarUpload(file) {
      var isLt2M = file.size / 1024 / 1024 < 2
      const fileName = file.name
      const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
      // if (!isLt2M) {
      //   this.$message({
      //     message: '上传文件大小不能超过 2MB!',
      //     type: 'warning'
      //   })
      //   return
      // }

      if (this.imageTypes.includes(fileType)) {
        return true

      } else {
        this.$message.error(
          '请上传正确的图片类型'
        )
        return false
      }
    },
    //封面设置
    uploadPicture(type) {
      if (!this.editFlag) {
        return
      }
      this.picType = type
      this.imgUrl = this.addForm[`pic${type}`]
      let option = {
        cropWidth: "375", cropHeight: "250", imgUrl: this.imgUrl
      }
      if (type == 3) {
        option.cropWidth = "375"
        option.cropHeight = "325"
      }
      this.$refs.cropperRef.initCropper(option)
    },

    beforeVideoUpload(file) {
      if (
        [
          "video/mp4",
          "video/ogg",
          "video/flv",
          "video/avi",
          "video/wmv",
          "video/rmvb",
          "video/mov",
        ].indexOf(file.type) == -1     //控制格式
      ) {
        this.$message.error("请上传正确的视频格式");
        return false;
      }
    },

    handleVideoSuccess(res) {
      if (res.success) {
        this.$message.success('上传成功')
        this.videoFlag = false;
        this.videoUploadPercent = 0;
        this.addForm.pic2 = res.result.attPath
        // this.addForm.sp = res.result.attId
        if (this.addForm.pic2) {
          this.$refs.form.clearValidate('pic2');
        }
      } else {
        this.$message.error(res.message)
      }
    },
    // 文件上传回调
    // uploadCallback(fileStr) {
    //   this.addForm.fwsjb = fileStr
    //   this.$refs.form.clearValidate('fwsjb');
    // },

    //进度条
    uploadVideoProcess(file, fileList) {    //注意在data中添加对应的变量名
      const self = this
      if (file.status === 'ready') {
        this.videoFlag = true; // 显示进度条
        this.videoUploadPercent = 0;
        const interval = setInterval(() => {
          if (self.videoUploadPercent >= 99) {
            clearInterval(interval)
            return
          }
          self.videoUploadPercent += 1

        }, 20);
      }
      if (file.status === 'success') {
        setTimeout(() => {
          this.videoFlag = false; // 显示进度条
          this.videoUploadPercent = 100;
        }, 500)
      }
    },
    // 封面上传前
    // beforeCoverUpload(file) {

    //   var isLt2M = file.size / 1024 / 1024 < 2
    //   const fileName = file.name
    //   const fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
    //   if (!isLt2M) {
    //     this.$message({
    //       message: '上传文件大小不能超过 2MB!',
    //       type: 'warning'
    //     })
    //     return false

    //   }

    //   if (this.imageTypes.includes(fileType)) {
    //     return true

    //   } else {
    //     this.$message.error(
    //       '请上传正确的图片类型'
    //     )
    //     return false

    //   }
    // },

    // handleCoverSuccess(res) {
    //   if (res.success) {
    //     this.$message.success('上传成功')
    //     this.coverUrl = res.result.attPath
    //     this.addForm.spfm = res.result.attId
    //   } else {
    //     this.$message.error(res.message)
    //   }
    // },

    // // 服务时间表
    // beforeServiceUpload(file) {
    //   var isLt2M = file.size / 1024 / 1024 < 2
    //   const fileName = file.name
    //   let fileType = fileName.substring(fileName.lastIndexOf('.') + 1)
    //   if (!isLt2M) {
    //     this.$message({
    //       message: '上传文件大小不能超过 2MB!',
    //       type: 'warning'
    //     })
    //     return false
    //   }

    //   if (this.imageTypes.includes(fileType)) {
    //     return true
    //   } else {
    //     this.$message.error(
    //       '请上传正确的图片类型'
    //     )
    //     return false
    //   }
    // },

    // handleServiceSuccess(res) {
    //   if (res.success) {
    //     this.$message.success('上传成功')
    //     this.serviceUrl = res.result.attPath
    //     this.addForm.fwsjb = res.result.attId
    //   } else {
    //     this.$message.error(res.message)
    //   }
    // },
    onSubmit() {
      const self = this
      let content = this.$refs.myCkeditor1.getContent() // 调用子组件方法
      if (!content) {
        this.$message.info('儿童体验馆介绍不能为空')
        return
      }
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.loadingSave = true
          let url = 'addPics'
          if (this.addForm.id) {
            url = 'updatePics'
          }
          this.$api.applet[url]({
            ...this.addForm,
            des: content,
            type: 5
          }).then(res => {
            this.loadingSave = false
            if (res.success) {
              if (this.addForm.id) {
                this.$message.success('修改成功')
              } else {
                this.$message.success('新增成功')
              }
              this.getData()
            } else {
              this.$message.warning(res.message)
            }
          }).catch(err => {
            this.loadingSave = false
          })
        }
      })
    },

    onEdit() {
      this.editFlag = true
    },

    getData() {
      this.listLoading = true
      this.editFlag = true
      this.$api.applet.getPics({
        type: 5
      }).then(res => {
        this.listLoading = false
        if (res.success) {

          if (res.result) {
            this.editFlag = false
            this.addForm = res.result
            this.imgUrl = this.addForm.pic1
          }
        } else {
          this.$message.error(res.message)
        }
      })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>

<style lang="scss" scoped>
.volunteer {
  box-sizing: border-box;
  padding: 40px;
  background: #fff;
  .volunteer-inner {
    display: flex;
    height: 100%;
    .form-wrapper {
      flex: 1;
      .el-form {
        height: 100%;
        display: flex;
        .left {
          display: flex;
          flex-direction: column;
          flex: 1;
          .el-form-item {
            // flex: 1;
            // height: 0;
            .uploader-form {
              width: 345px;
              height: 184px;
              display: flex;
              cursor: pointer;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              border: 1px dashed #8c939d;
              img {
                width: 100%;
                height: 100%;
              }
              i {
                font-size: 34px;
              }
            }

            &.url-wrapper {
              flex: 0 1 40px;
            }
            &.avatar-uploader-form {
              // width: 375px;
              // height: 215px;
              .video-wrapper {
                width: 345px;
                height: 184px;
              }
              /deep/ .el-form-item__content {
                height: 100%;
              }

              .avatar-uploader {
                width: 345px;
                height: 184px;
                box-sizing: border-box;
                border: 1px dashed #8c939d;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                /deep/.el-upload {
                  width: 100%;
                  height: 100%;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                }

                .el-icon-plus {
                  font-size: 20px;
                }

                .el-upload__text {
                  line-height: 1;
                }
              }
            }
            &:last-child {
              margin-bottom: 0;
            }
          }
        }

        .right {
          flex: 2;
          margin-bottom: 0;
          /deep/ .el-form-item__content {
            height: 100%;
          }
          .el-textarea {
            height: 100%;
            /deep/.el-textarea__inner {
              height: 100%;
              background: rgb(246, 247, 250);
            }
          }
        }
      }
    }
  }

  .btn {
    position: absolute;
    bottom: 40px;
    right: 40px;
  }
}
</style>